import { PondBase } from './base/pond-base';

export class Pond extends PondBase { }